module.exports = __webpack_public_path__ + "03167a20a05b4efa0256677718a33e18.svg";